import { render } from "./Footer.vue?vue&type=template&id=298dc073&scoped=true"
const script = {}

import "./Footer.vue?vue&type=style&index=0&id=298dc073&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-298dc073"]])

export default __exports__